import { createApp, h, type Component, nextTick } from "vue";

export function mountModal<TProps extends Record<string, unknown>>(
  modalComponent: Component<TProps>,
  props: TProps & { onClose?: () => void; onConfirm?: () => void },
) {
  const container = document.createElement("div");
  document.body.appendChild(container);

  const cleanupAndUnmount = () => {
    if (!container.isConnected) {
      return;
    }

    app.unmount();
    container.remove();
    props.onClose?.();
  };

  const app = createApp({
    render() {
      return h(modalComponent, {
        ...props,
        onCancel: () => {},
        onConfirm: () => {
          props.onConfirm?.();
        },
      });
    },
  });

  app.mount(container);

  nextTick(() => {
    const rootEl = container.querySelector(".modal");
    if (rootEl) {
      rootEl.addEventListener("hidden.bs.modal", cleanupAndUnmount);
    }
  });
}
